export default __webpack_public_path__ + "static/media/bellesDemeures.8b9acc54.svg";